// Variedades Management Extension for Sistema Module
// This file extends window.FazendaRP.Pages.sistema with variety management functions

// -----------------------------------------------------------------------------
// CATÁLOGO DE VARIEDADES (Master Data)
// -----------------------------------------------------------------------------

window.FazendaRP.Pages.sistema.renderListaVariedades = async function (container) {
    container.innerHTML = `
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
            <div style="position:relative; width: 300px;">
                <input type="text" id="search-variedades" class="form-control" placeholder="Buscar variedade..." style="padding-left: 35px;">
                <i class="fas fa-search" style="position:absolute; left:12px; top:10px; color:#9ca3af;"></i>
            </div>
            <button class="btn btn-primary" onclick="window.FazendaRP.Pages.sistema.openVariedadeCatalogoModal()">
                <i class="fas fa-plus"></i> Nova Variedade
            </button>
        </div>
        <div id="variedades-catalogo-list">
            <div style="text-align:center; padding:40px;"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>
        </div>
    `;

    await this.loadVariedadesCatalogo();

    // Evento de busca
    const searchInput = document.getElementById('search-variedades');
    searchInput.addEventListener('input', (e) => {
        const term = e.target.value.toLowerCase();
        const rows = document.querySelectorAll('.variedade-row');
        rows.forEach(row => {
            const text = row.innerText.toLowerCase();
            row.style.display = text.includes(term) ? '' : 'none';
        });
    });
};

window.FazendaRP.Pages.sistema.loadVariedadesCatalogo = async function () {
    const listContainer = document.getElementById('variedades-catalogo-list');
    if (!listContainer) return;

    try {
        const { data, error } = await window.FazendaRP.supabase
            .from('variedades_catalogo')
            .select('*')
            .order('cultura')
            .order('nome');

        if (error) throw error;

        if (!data || data.length === 0) {
            listContainer.innerHTML = `
                <div style="text-align:center; padding:50px; background:#f9fafb; border-radius:8px;">
                    <i class="fas fa-seedling" style="font-size:3rem; color:#d1d5db; margin-bottom:15px;"></i>
                    <p style="color:#6b7280;">Nenhuma variedade cadastrada no catálogo.</p>
                </div>
            `;
            return;
        }

        let html = `
            <table class="table" style="background:white; border-radius:8px; overflow:hidden; box-shadow:0 1px 3px rgba(0,0,0,0.1);">
                <thead style="background:#f3f4f6; color:#374151;">
                    <tr>
                        <th style="padding:15px;">Variedade</th>
                        <th style="padding:15px;">Cultura</th>
                        <th style="padding:15px;">Tipo / Ciclo</th>
                        <th style="padding:15px; text-align:right;">Ações</th>
                    </tr>
                </thead>
                <tbody>
        `;

        data.forEach(v => {
            // Ícone por cultura
            let iconColor = '#10b981'; // Default green
            if (v.cultura === 'Soja') iconColor = '#16a34a';
            else if (v.cultura === 'Milho') iconColor = '#eab308';
            else if (v.cultura === 'Trigo') iconColor = '#ca8a04';
            else if (v.cultura === 'Algodão') iconColor = '#cbd5e1';

            html += `
                <tr class="variedade-row" style="border-bottom:1px solid #e5e7eb;">
                    <td style="padding:15px;">
                        <strong style="color:#1f2937;">${v.nome}</strong>
                        ${v.descricao ? `<br><small style="color:#6b7280;">${v.descricao}</small>` : ''}
                    </td>
                    <td style="padding:15px;">
                        <span style="display:inline-flex; align-items:center; gap:6px; padding:4px 8px; background:${iconColor}20; color:${iconColor}; border-radius:12px; font-size:0.85rem; font-weight:600;">
                            <i class="fas fa-circle" style="font-size:0.5rem;"></i> ${v.cultura}
                        </span>
                    </td>
                    <td style="padding:15px; color:#4b5563;">
                        ${v.tipo ? `<span class="badge" style="background:#f3f4f6; color:#4b5563;">${v.tipo}</span>` : ''}
                        ${v.ciclo ? `<span class="badge" style="background:#f3f4f6; color:#4b5563;">${v.ciclo}</span>` : ''}
                    </td>
                    <td style="padding:15px; text-align:right;">
                        <button onclick="window.FazendaRP.Pages.sistema.openVariedadeCatalogoModal('${v.id}')" style="border:none; background:none; color:#3b82f6; cursor:pointer; margin-right:10px;" title="Editar">
                            <i class="fas fa-edit"></i>
                        </button>
                        <button onclick="window.FazendaRP.Pages.sistema.deleteVariedadeCatalogo('${v.id}')" style="border:none; background:none; color:#ef4444; cursor:pointer;" title="Inativar/Remover">
                            <i class="fas fa-trash"></i>
                        </button>
                    </td>
                </tr>
            `;
        });

        html += '</tbody></table>';
        listContainer.innerHTML = html;

    } catch (err) {
        console.error(err);
        listContainer.innerHTML = `<div class="alert alert-danger">Erro ao carregar catálogo: ${err.message}</div>`;
    }
};

window.FazendaRP.Pages.sistema.openVariedadeCatalogoModal = async function (id = null) {
    const isEdit = !!id;
    let variedade = {};

    if (isEdit) {
        const { data, error } = await window.FazendaRP.supabase
            .from('variedades_catalogo')
            .select('*')
            .eq('id', id)
            .single();

        if (error) {
            alert('Erro ao carregar detalhes: ' + error.message);
            return;
        }
        variedade = data;
    }

    const modalId = 'modal-catalogo-variedade';
    let modal = document.getElementById(modalId);
    if (modal) modal.remove();

    modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'modal-overlay';
    modal.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:9999;';

    modal.innerHTML = `
        <div style="background:white; border-radius:12px; width:500px; box-shadow:0 20px 25px rgba(0,0,0,0.2);">
            <div style="padding:20px; border-bottom:1px solid #e5e7eb; display:flex; justify-content:space-between; align-items:center;">
                <h3 style="margin:0; color:#1f2937;">${isEdit ? 'Editar Variedade' : 'Nova Variedade no Catálogo'}</h3>
                <button onclick="document.getElementById('${modalId}').remove()" style="background:none; border:none; font-size:1.5rem; cursor:pointer;">&times;</button>
            </div>
            <form id="form-catalogo-variedade" style="padding:20px;">
                <div style="margin-bottom:15px;">
                    <label style="display:block; font-weight:600; font-size:0.9rem; margin-bottom:5px;">Nome da Variedade *</label>
                    <input type="text" name="nome" class="form-control" value="${variedade.nome || ''}" required placeholder="Ex: TMG 7062" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                    <small style="color:#6b7280;">Nome único de identificação</small>
                </div>
                
                <div style="margin-bottom:15px;">
                    <label style="display:block; font-weight:600; font-size:0.9rem; margin-bottom:5px;">Cultura *</label>
                    <select name="cultura" class="form-control" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                        <option value="">Selecione...</option>
                        <option value="Soja" ${variedade.cultura === 'Soja' ? 'selected' : ''}>Soja</option>
                        <option value="Milho" ${variedade.cultura === 'Milho' ? 'selected' : ''}>Milho</option>
                        <option value="Trigo" ${variedade.cultura === 'Trigo' ? 'selected' : ''}>Trigo</option>
                        <option value="Algodão" ${variedade.cultura === 'Algodão' ? 'selected' : ''}>Algodão</option>
                        <option value="Sorgo" ${variedade.cultura === 'Sorgo' ? 'selected' : ''}>Sorgo</option>
                        <option value="Feijão" ${variedade.cultura === 'Feijão' ? 'selected' : ''}>Feijão</option>
                        <option value="Outro" ${variedade.cultura === 'Outro' ? 'selected' : ''}>Outro</option>
                    </select>
                </div>

                <div style="display:flex; gap:15px; margin-bottom:15px;">
                    <div style="flex:1;">
                        <label style="display:block; font-weight:600; font-size:0.9rem; margin-bottom:5px;">Tipo (Opcional)</label>
                        <input type="text" name="tipo" class="form-control" value="${variedade.tipo || ''}" placeholder="Ex: Transgênica" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                    <div style="flex:1;">
                        <label style="display:block; font-weight:600; font-size:0.9rem; margin-bottom:5px;">Ciclo (Opcional)</label>
                        <input type="text" name="ciclo" class="form-control" value="${variedade.ciclo || ''}" placeholder="Ex: Precoce" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                    </div>
                </div>

                <div style="margin-bottom:20px;">
                    <label style="display:block; font-weight:600; font-size:0.9rem; margin-bottom:5px;">Descrição (Opcional)</label>
                    <textarea name="descricao" class="form-control" rows="2" style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">${variedade.descricao || ''}</textarea>
                </div>

                <div style="text-align:right;">
                    <button type="button" onclick="document.getElementById('${modalId}').remove()" class="btn" style="background:#f3f4f6; color:#4b5563; border:none; padding:10px 20px; border-radius:6px; cursor:pointer; margin-right:10px;">Cancelar</button>
                    <button type="submit" class="btn btn-primary" style="padding:10px 20px;">
                        <i class="fas fa-save"></i> Salvar
                    </button>
                </div>
            </form>
        </div>
    `;

    document.body.appendChild(modal);

    document.getElementById('form-catalogo-variedade').addEventListener('submit', async (e) => {
        e.preventDefault();
        const form = e.target;
        const payload = {
            nome: form.nome.value.trim(),
            cultura: form.cultura.value,
            tipo: form.tipo.value.trim(),
            ciclo: form.ciclo.value.trim(),
            descricao: form.descricao.value.trim()
        };

        if (isEdit) {
            const { error } = await window.FazendaRP.supabase
                .from('variedades_catalogo')
                .update(payload)
                .eq('id', id);

            if (error) alert('Erro ao atualizar: ' + error.message);
            else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Variedade atualizada!');
                document.getElementById(modalId).remove();
                this.loadVariedadesCatalogo();
            }
        } else {
            const { error } = await window.FazendaRP.supabase
                .from('variedades_catalogo')
                .insert([payload]);

            if (error) {
                if (error.code === '23505') alert('Esta variedade já existe para esta cultura!');
                else alert('Erro ao criar: ' + error.message);
            } else {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Variedade criada!');
                document.getElementById(modalId).remove();
                this.loadVariedadesCatalogo();
            }
        }
    });
};

window.FazendaRP.Pages.sistema.deleteVariedadeCatalogo = async function (id) {
    if (!confirm('❌ Tem certeza? Isso não afeta safras passadas que já usaram, mas impede novos usos.')) return;

    const { error } = await window.FazendaRP.supabase
        .from('variedades_catalogo')
        .delete()
        .eq('id', id);

    if (error) {
        // Provavelmente erro de FK se já estiver sendo usada em constraint restritiva
        // Se a FK for SET NULL ou CASCADE, apaga. Mas geralmente queremos impedir.
        // Vamos checar o erro.
        if (error.message.includes('foreign key constraint')) {
            alert('⚠️ Não é possível excluir pois esta variedade já está vinculada a safras/áreas. Edite o nome se necessário.');
        } else {
            alert('Erro ao excluir: ' + error.message);
        }
    } else {
        window.FazendaRP.Toast.show('success', 'Sucesso', 'Variedade removida do catálogo!');
        this.loadVariedadesCatalogo();
    }
};


// -----------------------------------------------------------------------------
// VÍNCULO DE VARIEDADES POR SAFRA (Usa o catálogo)
// -----------------------------------------------------------------------------
// ... Mantendo o código anterior do sistema_variedades.js que gerencia a Safra,
// mas vou precisar atualizá-lo para usar dropdowns do catálogo em breve.
// Por enquanto, mantenho a função openVariedadesModal aqui, mas você vai me pedir
// para atualizar na próxima etapa.

window.FazendaRP.Pages.sistema.openVariedadesModal = async function (safraId, ano, cultura, areaTotal) {
    // ... Código antigo (input text) ...
    // Vou substituir isso na próxima task.
    // Por enquanto, vou carregar o código antigo do arquivo se ele existir, ou
    // deixar um placeholder funcional se o objetivo for atualizar tudo de uma vez.
    // Como estou reescrevendo o arquivo, preciso colocar o codigo funcional da safra aqui também.
    // Mas vou atualizar JÁ para usar o dropdown, poupando trabalho.

    // Fetch areas (com join se possível, ou fetch separado)
    // Supabase join syntax: select(*, variedades_catalogo(nome))

    const { data: areas, error } = await window.FazendaRP.supabase
        .from('safras_areas')
        .select(`
            *,
            variedades_catalogo (
                id,
                nome
            )
        `)
        .eq('safra_id', safraId);

    if (error) {
        window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao carregar variedades da safra.');
        return;
    }

    const variedades = (areas || []).map(a => ({
        id: a.id,
        // Fallback para nome antigo se variedade_id for nulo (migração)
        variedade: a.variedades_catalogo ? a.variedades_catalogo.nome : (a.variedade || a.variedade_nome_temp || 'Sem Nome'),
        area_ha: a.area_ha,
        variedade_id: a.variedade_id
    })).sort((a, b) => a.variedade.localeCompare(b.variedade));

    const areaUsada = variedades.reduce((sum, v) => sum + (v.area_ha || 0), 0);
    const areaDisponivel = areaTotal - areaUsada;

    // Create modal
    const modalId = 'modal-variedades-safra';
    let modal = document.getElementById(modalId);
    if (modal) modal.remove();

    modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'modal-overlay';
    modal.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:9999;';

    modal.innerHTML = `
        <div style="background:white; border-radius:12px; width:700px; max-height:80vh; display:flex; flex-direction:column; box-shadow:0 20px 25px rgba(0,0,0,0.2);">
            <!-- Header -->
            <div style="padding:20px 25px; border-bottom:1px solid #e5e7eb; display:flex; justify-content:space-between; align-items:center;">
                <div>
                    <h3 style="margin:0; font-size:1.2rem; color:#1f2937;">🌱 Variedades - ${ano} ${cultura}</h3>
                    <div style="font-size:0.85rem; color:#6b7280; margin-top:5px;">
                        <span style="color:${areaDisponivel < 0 ? '#ef4444' : '#059669'}; font-weight:600;">${areaDisponivel.toFixed(2)} ha disponíveis</span>
                        de ${areaTotal} ha
                    </div>
                </div>
                <button onclick="document.getElementById('${modalId}').remove()" style="background:none; border:none; font-size:1.5rem; color:#9ca3af; cursor:pointer; padding:0; width:30px; height:30px;">&times;</button>
            </div>

            <!-- Variedades List -->
            <div style="flex:1; overflow-y:auto; padding:20px 25px;" id="variedades-list-container">
                ${variedades.length > 0 ? `
                    <table style="width:100%; border-collapse:collapse;">
                        <thead>
                            <tr style="border-bottom:2px solid #e5e7eb; color:#6b7280; text-align:left;">
                                <th style="padding:10px;">Variedade</th>
                                <th style="padding:10px; width:120px;">Área (ha)</th>
                                <th style="padding:10px; width:80px; text-align:center;">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${variedades.map(v => `
                                <tr style="border-bottom:1px solid #f3f4f6;">
                                    <td style="padding:12px; font-weight:500; color:#374151;">${v.variedade}</td>
                                    <td style="padding:12px; color:#6b7280;">${v.area_ha} ha</td>
                                    <td style="padding:12px; text-align:center;">
                                        <button onclick="window.FazendaRP.Pages.sistema.deleteVariedadeFromSafra('${v.id}', ${safraId}, '${ano}', '${cultura}', ${areaTotal})" style="border:none; background:none; color:#ef4444; cursor:pointer;" title="Remover">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                ` : `
                    <div style="text-align:center; padding:40px; color:#9ca3af;">
                        <i class="fas fa-seedling" style="font-size:3rem; margin-bottom:15px; opacity:0.3;"></i>
                        <p style="margin:0; font-size:1rem;">Nenhuma variedade alocada nesta safra</p>
                    </div>
                `}
            </div>

            <!-- Footer -->
            <div style="padding:15px 25px; border-top:1px solid #e5e7eb; display:flex; justify-content:space-between; align-items:center; background:#f9fafb;">
                <div style="font-size:0.9rem; color:#4b5563;">
                    <strong>${variedades.length}</strong> alocada(s) • 
                    <strong>${areaUsada.toFixed(2)} ha</strong> total
                </div>
                <button id="btn-alocar-variedade-safra" class="btn btn-primary" style="display:flex; align-items:center; gap:8px;">
                    <i class="fas fa-plus"></i> Alocar Variedade
                </button>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    // Attach event listener properly
    const btnAlocar = document.getElementById('btn-alocar-variedade-safra');
    if (btnAlocar) {
        btnAlocar.addEventListener('click', () => {
            window.FazendaRP.Pages.sistema.openAddVariedadeToSafraModal(safraId, ano, cultura, areaTotal);
        });
    }
};

window.FazendaRP.Pages.sistema.openAddVariedadeToSafraModal = async function (safraId, ano, cultura, areaTotal) {
    // 1. Fetch available varieties from catalog (filtered by culture)
    const { data: catalogo, error } = await window.FazendaRP.supabase
        .from('variedades_catalogo')
        .select('*')
        .eq('cultura', cultura) // Filtra pela cultura da safra (ex: só mostra Soja se safra for Soja). Melhor UX!
        .order('nome');

    if (error) {
        alert('Erro ao carregar catálogo: ' + error.message);
        return;
    }

    if (!catalogo || catalogo.length === 0) {
        alert(`Não há variedades de ${cultura} cadastradas no catálogo. Por favor, cadastre primeiro na aba "Variedades".`);
        window.FazendaRP.Pages.sistema.renderTabContent('variedades'); // Navega par aba variedades (se possível)
        return;
    }

    // Calcula area disponível
    const { data: areas } = await window.FazendaRP.supabase
        .from('safras_areas')
        .select('area_ha')
        .eq('safra_id', safraId);

    const areaUsada = (areas || []).reduce((sum, v) => sum + (v.area_ha || 0), 0);
    const areaDisponivel = Math.max(0, areaTotal - areaUsada);

    const formId = 'modal-add-variedade-safra';
    let formModal = document.getElementById(formId);
    if (formModal) formModal.remove();

    formModal = document.createElement('div');
    formModal.id = formId;
    formModal.className = 'modal-overlay';
    formModal.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.6); display:flex; align-items:center; justify-content:center; z-index:10000;';

    formModal.innerHTML = `
        <div style="background:white; border-radius:12px; width:500px; box-shadow:0 20px 25px rgba(0,0,0,0.3);">
            <div style="padding:20px 25px; border-bottom:1px solid #e5e7eb;">
                <h3 style="margin:0; font-size:1.1rem; color:#1f2937;">🌱 Alocar Variedade - ${cultura}</h3>
            </div>
            
            <form id="form-alocar-variedade" style="padding:25px;">
                <div style="margin-bottom:20px;">
                    <label style="display:block; font-weight:600; font-size:0.9rem; color:#374151; margin-bottom:8px;">Selecione a Variedade *</label>
                    <select id="select-variedade-id" class="form-control" required style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;">
                        <option value="">-- Escolha do Catálogo --</option>
                        ${catalogo.map(v => `<option value="${v.id}">${v.nome} (${v.ciclo || '-'})</option>`).join('')}
                    </select>
                    <small style="display:block; margin-top:5px; color:#3b82f6; cursor:pointer;" onclick="document.getElementById('${formId}').remove(); window.FazendaRP.Pages.sistema.openVariedadeCatalogoModal();">
                        + Cadastrar nova variedade no catálogo
                    </small>
                </div>

                <div style="margin-bottom:20px;">
                    <label style="display:block; font-weight:600; font-size:0.9rem; color:#374151; margin-bottom:8px;">Área Plantada (ha) *</label>
                    <input 
                        type="number" 
                        id="input-area-alocar" 
                        class="form-control" 
                        placeholder="0.00" 
                        step="0.01" 
                        max="${areaDisponivel}"
                        required 
                        style="width:100%; padding:10px; border:1px solid #d1d5db; border-radius:6px;"
                    >
                    <small style="color:${areaDisponivel > 0 ? '#059669' : '#dc2626'}">Disponível: ${areaDisponivel.toFixed(2)} ha</small>
                </div>

                <div style="text-align:right; display:flex; justify-content:flex-end; gap:10px;">
                    <button type="button" onclick="document.getElementById('${formId}').remove()" class="btn" style="background:#f3f4f6; color:#4b5563; border:none; padding:10px 20px; border-radius:6px; cursor:pointer;">Cancelar</button>
                    <button type="submit" class="btn btn-primary" style="padding:10px 20px;">Confirmar</button>
                </div>
            </form>
        </div>
    `;

    document.body.appendChild(formModal);

    document.getElementById('form-alocar-variedade').addEventListener('submit', async (e) => {
        e.preventDefault();
        const variedadeId = document.getElementById('select-variedade-id').value;
        const area = parseFloat(document.getElementById('input-area-alocar').value);

        if (!variedadeId || !area || area <= 0) {
            alert('Dados inválidos.');
            return;
        }

        if (area > areaDisponivel) {
            alert(`A área informada (${area} ha) excede a área disponível (${areaDisponivel.toFixed(2)} ha).`);
            return;
        }

        const payload = {
            safra_id: safraId,
            variedade_id: variedadeId,
            area_ha: area,
            // Fallback para nome para sistemas legados que leem 'variedade'
            variedade: catalogo.find(c => c.id === variedadeId).nome
        };

        const { error } = await window.FazendaRP.supabase
            .from('safras_areas')
            .insert([payload]);

        if (error) {
            alert('Erro ao salvar: ' + error.message);
        } else {
            window.FazendaRP.Toast.show('success', 'Sucesso', 'Variedade alocada!');
            document.getElementById(formId).remove();
            window.FazendaRP.Pages.sistema.openVariedadesModal(safraId, ano, cultura, areaTotal);
        }
    });
};

window.FazendaRP.Pages.sistema.deleteVariedadeFromSafra = async function (id, safraId, ano, cultura, areaTotal) {
    if (!confirm('Remover esta alocação de variedade da safra?')) return;

    const { error } = await window.FazendaRP.supabase.from('safras_areas').delete().eq('id', id);

    if (error) alert('Erro: ' + error.message);
    else {
        window.FazendaRP.Toast.show('success', 'Removido', 'Alocação removida.');
        window.FazendaRP.Pages.sistema.openVariedadesModal(safraId, ano, cultura, areaTotal);
    }
};
